import { Button } from "@tremor/react";
import PropTypes from "prop-types";

export const DeleteModal = ({
  information = "",
  cancelFunction = () => console.log("first"),
  confirmFunction = () => console.log("second"),
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="bg-white p-6 rounded shadow-lg z-10">
        <h2 className="text-xl font-bold mb-4">
          Desear eliminar la siguiente informacion:{information}?
        </h2>
        <div className="flex justify-between">
          <Button variant="secondary" onClick={cancelFunction}>
            Cancelar
          </Button>
          <Button onClick={confirmFunction}>Eliminar</Button>
        </div>
      </div>
    </div>
  );
};

DeleteModal.propTypes = {
  information: PropTypes.string,
  cancelFunction: PropTypes.func,
  confirmFunction: PropTypes.func,
};
